<template>
  <div class="h-100">
    <div
      class="row mb-3"
      v-if="
        registrationsList.length ||
        (!registrationsList.length && isFilterSelected) ||
        (!isLoaded && (registrationsList.length || isFilterSelected)) ||
        (!isLoaded && isFilterSelected && !registrationsList.length)
      "
    >
      <div class="col-md-12">
        <form action="" @submit.prevent class="h-100">
          <ValidationObserver ref="form" v-slot="{}">
            <div class="row d-flex justify-content-between">
              <div class="col-md-4">
                <div class="form-group mb-2">
                  <validation-provider
                    name="recherche"
                    rules="min:3"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      name="search"
                      v-model.trim="q"
                      v-debounce:1s.fireonempty="search"
                      class="form-control form-control_search"
                      :placeholder="$t('buttons.searchByName')"
                      :class="{ 'is-invalid': errors.length }"
                      @input="isLoaded = false"
                    />
                    <span class="text-danger small">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="col-md-4 d-flex justify-content-end">
                <div>
                  <button
                    class="btn btn-icon ml-4"
                    :class="
                      (selectedFilterItems && selectedFilterItems.length) ||
                      statusFilter
                        ? 'btn-dark'
                        : 'btn-filter '
                    "
                    type="button"
                    @click.prevent.stop="showFilterModal"
                  >
                    <span
                      :class="
                        (selectedFilterItems && selectedFilterItems.length) ||
                        statusFilter
                          ? 'icon icon-filter-light'
                          : 'icon icon-filter'
                      "
                    />
                    <span class="">
                      {{ $t('filter') }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </form>
      </div>
    </div>

    <div class="row h-100">
      <div class="col-md-12">
        <div
          class="legend mb-3"
          v-if="
            registrationsList.length ||
            (!registrationsList.length && isFilterSelected) ||
            (!isLoaded && (registrationsList.length || isFilterSelected)) ||
            (!isLoaded && isFilterSelected && !registrationsList.length)
          "
        >
          <div class="legend__items">
            <div class="legend__header">
              {{ $t('legend') }}
            </div>

            <a
              href="#"
              @click.prevent.stop="filterByStatus(3)"
              :class="statusFilter == 3 ? 'legend__item-filtrable-active' : ''"
              class="legend__item legend__item-filtrable cursor-pointer d-flex align-items-center"
            >
              <div class="icon icon-success-badge"></div>
              <div>{{ $t('SucceededStatus') }}</div>
            </a>

            <a
              href="#"
              @click.prevent.stop="filterByStatus(2)"
              :class="statusFilter == 2 ? 'legend__item-filtrable-active' : ''"
              class="legend__item legend__item-filtrable cursor-pointer d-flex align-items-center"
            >
              <div class="icon icon-fail-badge"></div>
              <div>{{ $t('FailedStatus') }}</div>
            </a>

            <a
              href="#"
              @click.prevent.stop="filterByStatus(1)"
              :class="statusFilter == 1 ? 'legend__item-filtrable-active' : ''"
              class="legend__item legend__item-filtrable cursor-pointer d-flex align-items-center"
            >
              <div class="icon icon-in-progress-badge"></div>
              <div>{{ $t('InProgressStatus') }}</div>
            </a>

            <a
              href="#"
              @click.prevent.stop="filterByStatus(4)"
              :class="statusFilter == 4 ? 'legend__item-filtrable-active' : ''"
              class="legend__item legend__item-filtrable cursor-pointer d-flex align-items-center"
            >
              <div class="icon icon-not-started"></div>
              <div>{{ $t('NotStartedStatus') }}</div>
            </a>
          </div>
          <div>
            <div class="d-flex justify-content-end" v-if="isFilterSelected">
              <button
                class="btn btn-reset-filter btn-icon px-0"
                @click="resetFilter"
              >
                {{ $t('resetFilter') }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="isLoaded">
          <div class="text-center">
            <div
              class="box-block text-center"
              v-cloak
              v-if="!registrationsList.length && isFilterSelected"
            >
              <div class="alert alert-primary mb-0">
                {{ $t('emptyFiltredRegitrationList') }}
              </div>
            </div>
            <div
              class="box-block text-center"
              v-cloak
              v-else-if="!registrationsList.length"
            >
              <div class="alert alert-primary mb-0">
                {{ $t('emptyRegitrationList') }}
              </div>
            </div>

            <div
              v-if="registrationsList.length"
              v-cloak
              class="dates dates_users"
            >
              <table
                class="table profile-table table-responsive-lg overflow-y-xs text-left"
              >
                <th>{{ $t('id') }}</th>
                <th>{{ $t('form.name') }}</th>
                <th>{{ $t('courseLanguage') }}</th>
                <th>{{ $t('training') }}</th>
                <th>{{ $t('RegistrationDate') }}</th>
                <!--<th>{{ $t('sessionDate') }}</th>-->
                <th>{{ $t('form.status') }}</th>
                <tbody class="box-block">
                  <registration-row
                    v-for="(registration, index) in registrationsList"
                    :key="'' + registration.id + index"
                    :index="index"
                    :registration="registration"
                    :user="user"
                  ></registration-row>
                </tbody>
              </table>
              <div class="row mt-3 mb-3" v-if="totalPages > 1">
                <div class="col-sm-12 d-flex justify-content-between">
                  <div class="">
                    <button
                      class="btn btn-filter btn-icon"
                      @click="previousPage()"
                    >
                      <span class="icon icon-arrow-left" /> {{ $t('previous') }}
                    </button>
                  </div>
                  <div>{{ $t('pagination', [page, totalPages]) }}</div>
                  <div class="">
                    <button class="btn btn-filter btn-icon" @click="nextPage()">
                      {{ $t('next') }} <span class="icon icon-arrow-right" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="h-100">
          <div
            class="h-100 row d-flex justify-content-center align-items-center"
          >
            <div class="col-12">
              <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FilterModal />
    <confirmation-modal></confirmation-modal>
  </div>
</template>

<script>
import ConfirmationModal from '@/js/components/modals/ConfirmationModal.vue'
import RegistrationRow from './RegistrationRow.vue'
import FilterModal from './FilterModal.vue'
import { mapFields } from 'vuex-map-fields'
import { lazyInput } from 'vue-lazy-input'
export default {
  name: 'Registrations',
  components: {
    ConfirmationModal,
    RegistrationRow,
    FilterModal,
  },
  directives: {
    lazyInput,
  },
  data() {
    return {
      page: 1,
      q: '',
      registrationsList: [],
      selectedFilterItems: [],
      lastTrimedQuery: '',
      form: {
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        gender: 0,
      },
      queryPayload: {
        page: 1,
        limit: this.limit,
      },
      isLoaded: false,
      locale: '',
      filterData: {},
      statusFilter: null,
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user']),
    ...mapFields([
      'registrations.registrations',
      'registrations.filtredRegistrations',
      'registrations.pagination',
      'registrations.limit',
    ]),

    totalPages() {
      return this.$lodash.get(this.pagination, 'total_pages', 1)
    },
    isFilterSelected() {
      if (
        this.statusFilter ||
        this.q ||
        (this.selectedFilterItems && this.selectedFilterItems.length)
      ) {
        return true
      } else return false
    },
  },
  watch: {
    page: (val) => {
      if (val < 1) this.page = 1
    },
    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          console.log('this.$route.query ', this.$route.query)
          let payload = {
            params: {
              ...{ page: this.page, limit: this.limit },
              ...this.$route.query,
            },
          }

          this.filter(payload)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.filtredRegistrations = []
    this.locale = this.user.local
    this.$bus.$on('registration-filter', (data) => {
      this.selectedFilterItems = data.filterData
      let params = data.data
      console.log('this.q ', this.q)
      if (this.q) {
        params = {
          ...params,
          action: 'search',
          q: this.q,
        }
      }
      let payload = {
        params,
        id: this.user.id,
      }
      this.queryPayload = payload.params
      this.$router
        .replace({ query: this.queryPayload })
        .then(() => {
          this.filterData.startDate = data.data.startDate
          this.filterData.endDate = data.data.endDate
          this.filterData.languge = data.data.languge
          this.filterData.training = data.data.training
          this.filterData.status = data.data.status
          this.statusFilter = data.data.status
          this.$bus.$emit('hide-filter-registration-modal')
        })
        .catch((error) => {})
      // this.filter(payload).then(() => {
      // })
    })
  },
  beforeMount() {
    this.$bus.$off('registration-filter')
  },
  methods: {
    resetFilter() {
      // this.isLoaded = false
      this.q = ''
      this.lastTrimedQuery = ''
      this.statusFilter = 0
      this.filterData.startDate = null
      this.filterData.endDate = null
      this.filterData.languge = null
      this.filterData.training = null
      this.filterData.status = null
      this.selectedFilterItems = []
      this.queryPayload = {
        ...{ page: 1, limit: this.limit },
      }
      this.selectedFilterItems = []
      this.$router.replace({ query: this.queryPayload }).catch((error) => {})
      console.log('this.filterData ', this.filterData)
      this.$bus.$emit('reset-registrations-filter')

      // this.isLoaded = true
    },
    showFilterModal() {
      this.$bus.$emit('filter-registration-modal.show', {
        statusFilter: this.statusFilter,
      })
    },
    nextPage() {
      if (
        this.pagination.total_pages > 1 &&
        this.page < this.pagination.total_pages
      ) {
        this.page++
        this.queryPayload = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...this.filterData,
        }
        this.$router
          .push({ name: 'Registrations', query: this.queryPayload })
          .catch((error) => {})
      }
    },
    previousPage() {
      if (this.pagination.total_pages > 1 && this.page > 1) {
        this.page--
        this.queryPayload = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...this.filterData,
        }
        this.$router
          .push({ name: 'Registrations', query: this.queryPayload })
          .catch((error) => {})
      }
    },
    search() {
      if (this.q != '') {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (this.lastTrimedQuery == qString.trim()) {
          return
        }
        if (qString.length < 2) return
        this.isLoaded = false
        let payload = {
          params: {
            action: 'search',
            q: qString,
            ...{ page: 1, limit: this.limit },
            ...this.filterData,
          },
          id: this.user.id,
        }
        this.lastTrimedQuery = qString.trim()
        this.queryPayload = payload.params

        this.$router.replace({ query: this.queryPayload }).catch((error) => {})
      } else {
        this.queryPayload = {
          ...{ page: 1, limit: this.limit },
          ...this.filterData,
          q: '',
        }
        console.log('this.queryPayload')
        this.lastTrimedQuery = ''
        this.$router
          .replace({ query: this.queryPayload })
          .then(() => {
            this.filtredRegistrations = []
          })
          .catch((error) => {})

        // this.getRegistrations(a)
      }
    },
    filterByStatus(status) {
      this.filterData.status = status

      let data = {
        ...this.$route.query,
        ...{ page: 1, limit: this.limit },
        ...this.filterData,
      }
      if (this.q != '') {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (qString.length < 2) return
        data = { ...data, action: 'search', q: qString }
      }
      this.filterData.status = status
      this.statusFilter = status
      let payload = {
        params: {
          ...data,
        },
        id: this.user.id,
      }
      this.queryPayload = payload.params
      // this.filter(payload)
      this.$router.replace({ query: this.queryPayload }).catch((error) => {})
    },
    filter(params) {
      console.log('params ', params)
      this.isLoaded = false

      return this.$store
        .dispatch('registrations/searchRegistrations', params)
        .then(() => {
          this.registrationsList = this.filtredRegistrations
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    getRegistrations(params) {
      this.isLoaded = false
      return this.$store
        .dispatch('registrations/getRegistrationsByClientId', params)
        .then(() => {
          this.registrationsList = this.registrations
        })
        .finally(() => {
          this.isLoaded = true
        })
    },

    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.legend {
  justify-content: space-between;
}
</style>
